module.exports = __webpack_public_path__ + "img/avatar4.8ae18762.svg";